import moment from 'moment'
import React from 'react'
import { apiUrl } from '../../../../config'
import utils from '../../../../utils'
import {
  FEEDBACK_BOARD_TAB,
  getPlykSuffixByTab,
  toDisplayDocumentNumber,
} from '../feedbackBoardType'
import RiskHorizontalDisplay from './RiskHorizontalDisplay'

const ExportPdf = ({
  feedbackDetailData,
  selectedOption,
  comment,
  currentUser,
  selectedIndex,
  feedbackTab,
}) => {
  const {
    title,
    endDate,
    createdAt,
    purpose,
    feedbackComments,
    fileIdAttachment,
    documentNumber,
  } = feedbackDetailData

  const ballotCreatedDate = createdAt ? new Date(createdAt) : new Date()
  const ballotDay = String(ballotCreatedDate.getDate()).padStart(2, '0')
  const ballotMonth = String(ballotCreatedDate.getMonth() + 1).padStart(2, '0')
  const ballotYear = ballotCreatedDate.getFullYear()

  const formattedEndDate = endDate
    ? moment(endDate).format('HH:mm [ngày] DD/MM/YYYY')
    : ''

  const normalizedFeedbackTab = feedbackTab || FEEDBACK_BOARD_TAB.HDQT
  const ballotSuffix = getPlykSuffixByTab(normalizedFeedbackTab)
  const normalizedDocumentNumber = toDisplayDocumentNumber(documentNumber)
  const displayDocumentNumber = normalizedDocumentNumber
    ? `${normalizedDocumentNumber}/${ballotSuffix}`
    : `..../${ballotSuffix}`

  const checkedUrl = `${window.location.protocol}//${window.location.host}/assets/icons/checkedbox.PNG`
  const uncheckedUrl = `${window.location.protocol}//${window.location.host}/assets/icons/uncheckedbox.PNG`

  return (
    <div
      id="divToPrintPart1"
      style={{
        margin: '20mm',
        paddingTop: '20mm',
        paddingRight: '15mm',
        pageBreakInside: 'avoid',
        fontFamily: 'Times New Roman, serif',
        fontSize: '12pt',
        width: '754px',
        boxSizing: 'border-box',
        wordWrap: 'break-word',
      }}>
      <style>{`
        #divToPrintPart1 figure { width: 100% !important; max-width: 100% !important; margin: 10px 0 !important; overflow: hidden; }
        #divToPrintPart1 figure img { width: 100% !important; max-width: 100% !important; height: auto !important; display: block; object-fit: contain; }
        #divToPrintPart1 img { width: 100% !important; max-width: 100% !important; height: auto !important; object-fit: contain; }
        #divToPrintPart1 table { max-width: 100% !important; box-sizing: border-box; }
        .rich-content, .rich-content * { max-width: 100% !important; box-sizing: border-box; }
        .rich-content p { word-break: break-word; overflow-wrap: break-word; margin: 2px 0; }
        .rich-content div { margin: 2px 0 !important; }
        .rich-content span { word-break: break-word; overflow-wrap: break-word; }
        .rich-content ul, .rich-content ol { margin: 2px 0 2px 20px !important; padding-left: 20px !important; }
        .rich-content li { word-break: break-word; overflow-wrap: break-word; margin: 2px 0 !important; }
        .rich-content table { table-layout: fixed !important; max-width: 100% !important; width: 100% !important; }
        .rich-content td, .rich-content th { word-break: break-word; overflow-wrap: break-word; overflow: hidden; }
        .rich-content strong { font-weight: bold; }
        .rich-content em, .rich-content i { font-style: italic; }
      `}</style>
      {/* Header */}
      <RiskHorizontalDisplay
        labels={[
          {
            image: (
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontWeight: 'bold' }}>TỔNG CÔNG TY</div>
                <div style={{ fontWeight: 'bold' }}>
                  HÀNG HẢI VIỆT NAM - CTCP
                </div>
                <div>---------------------</div>
                <div>Số: {displayDocumentNumber}</div>
              </div>
            ),
            style: { margin: '10px', border: '1px solid white' },
          },
          {
            image: (
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontWeight: 'bold' }}>
                  CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM
                </div>
                <div style={{ fontWeight: 'bold' }}>
                  Độc lập - Tự do - Hạnh phúc
                </div>
                <div>---------------------</div>
                <div style={{ fontStyle: 'italic' }}>
                  {`Hà Nội, ngày ${ballotDay} tháng ${ballotMonth} năm ${ballotYear}`}
                </div>
              </div>
            ),
            style: { margin: '10px 0 10px 10px', border: '1px solid white' },
          },
        ]}
        tableStyle={{ margin: '0 0 0 40px', width: 'calc(100% - 40px)' }}
      />

      {/* Title */}
      <RiskHorizontalDisplay
        results={[
          {
            value: (
              <div style={{ textAlign: 'center' }}>
                <div
                  style={{
                    fontWeight: 'bold',
                    fontSize: '13pt',
                    marginBottom: '6px',
                  }}>
                  PHIẾU LẤY Ý KIẾN
                </div>
                <div>
                  Kính gửi: <span style={{ fontWeight: 'bold' }}>Ông</span>{' '}
                  <span style={{ fontWeight: 'bold' }}>
                    {utils.getNameInCapitalize(currentUser?.name_uppercase)}
                  </span>
                </div>
                <div style={{ fontWeight: 'bold' }}>
                  Hội đồng quản trị Tổng công ty Hàng hải Việt Nam - CTCP
                </div>
              </div>
            ),
            style: { margin: '10px 0', border: '1px solid white' },
          },
        ]}
        tableStyle={{ margin: '0 auto', width: '100%', maxWidth: '100%' }}
      />

      {/* I. THÔNG TIN CÔNG TY */}
      <div style={{ margin: '10px 0 0 50px', textAlign: 'left' }}>
        <div style={{ fontWeight: 'bold', marginBottom: '6px' }}>
          I. THÔNG TIN CÔNG TY
        </div>
        <div style={{ marginBottom: '6px' }}>
          Tên công ty: Tổng công ty Hàng hải Việt Nam – CTCP.
        </div>
        <div style={{ marginBottom: '6px' }}>
          Trụ sở chính: Số 1 Đào Duy Anh, P. Kim Liên, TP. Hà Nội.
        </div>
        <div style={{ marginBottom: '6px' }}>
          Mã số doanh nghiệp: 0100104595.
        </div>
      </div>

      {/* II. MỤC ĐÍCH, VẤN ĐỀ CẦN LẤY Ý KIẾN */}
      <div
        style={{
          margin: '10px 0 8px 50px',
          textAlign: 'left',
          wordBreak: 'break-word',
          overflowWrap: 'break-word',
        }}>
        <div style={{ fontWeight: 'bold', marginBottom: '6px' }}>
          II. MỤC ĐÍCH, VẤN ĐỀ CẦN LẤY Ý KIẾN
        </div>
        <div style={{ marginBottom: '6px' }}>
          <span style={{ fontWeight: 'bold' }}>1. Mục đích: </span>
          <span dangerouslySetInnerHTML={{ __html: purpose || '...' }} />
        </div>
        <div style={{ marginBottom: '6px' }}>
          <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
            2. Vấn đề cần lấy ý kiến:{' '}
            <span style={{ fontWeight: 'normal' }}>{title}</span>
          </div>
          {feedbackComments?.map((item, idx) => {
            let uniformHtml = item.content || ''
            if (typeof window !== 'undefined' && window.DOMParser) {
              const parser = new DOMParser()
              const doc = parser.parseFromString(uniformHtml, 'text/html')
              doc.querySelectorAll('p, div, span').forEach(el => {
                el.style.removeProperty('margin-left')
                el.style.removeProperty('padding-left')
                el.style.removeProperty('text-indent')
              })
              doc.querySelectorAll('figure.image').forEach(figure => {
                figure.style.setProperty('width', '460pt', 'important')
              })
              doc.querySelectorAll('img').forEach(img => {
                img.style.setProperty('width', '460pt', 'important')
                img.style.setProperty('height', 'auto', 'important')
                img.style.setProperty('object-fit', 'contain', 'important')
              })
              uniformHtml = doc.body.innerHTML
            }

            return (
              <div key={idx} style={{ marginBottom: '8px' }}>
                <div style={{ fontWeight: 'bold', marginBottom: '4px' }}>
                  Nội dung {idx + 1}:
                </div>
                <div
                  className="rich-content"
                  style={{
                    margin: 0,
                    paddingRight: '5mm',
                    textAlign: 'justify',
                    lineHeight: '1.7',
                    wordBreak: 'break-word',
                    overflowWrap: 'break-word',
                  }}
                  dangerouslySetInnerHTML={{ __html: uniformHtml }}
                />
              </div>
            )
          })}
        </div>
      </div>

      {/* III. Tiêu đề */}
      <RiskHorizontalDisplay
        results={[
          {
            value: (
              <div style={{ fontWeight: 'bold' }}>
                III. TÀI LIỆU KÈM THEO PHIẾU LẤY Ý KIẾN
              </div>
            ),
            style: {
              border: '1px solid white',
              margin: '0 10px',
              textAlign: 'left',
              paddingLeft: '0',
            },
          },
        ]}
        tableStyle={{ margin: '0 0 0 40px', width: 'calc(100% - 40px)' }}
      />

      {/* III. Danh sách file */}
      <RiskHorizontalDisplay
        results={[
          {
            value: (
              <div style={{ textAlign: 'left' }}>
                {fileIdAttachment && fileIdAttachment.length > 0 ? (
                  <ul
                    style={{
                      paddingLeft: '20px',
                      margin: 0,
                      textAlign: 'left',
                    }}>
                    {fileIdAttachment.map((file, idx) => (
                      <li key={idx} style={{ lineHeight: 1.2 }}>
                        <div style={{ marginBottom: 8, textAlign: 'left' }}>
                          <a
                            href={`${apiUrl}/api/v1/images/${file.fileId}`}
                            target="_blank"
                            rel="noopener noreferrer">
                            {file.fileName}
                          </a>
                        </div>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <i style={{ color: '#888', fontSize: 14 }}>
                    &nbsp;Không có tài liệu đính kèm.
                  </i>
                )}
              </div>
            ),
            style: { border: '1px solid white', margin: '0 10px' },
          },
        ]}
        tableStyle={{ margin: '0 0 0 40px', width: 'calc(100% - 40px)' }}
      />

      {/* IV. Thời hạn */}
      <RiskHorizontalDisplay
        results={[
          {
            value: (
              <div>
                <span style={{ fontWeight: 'bold' }}>
                  IV. THỜI HẠN GỬI PHIẾU LẤY Ý KIẾN:{' '}
                </span>
                <span style={{ fontStyle: 'italic' }}>
                  {'Trước ' + formattedEndDate}
                </span>
              </div>
            ),
            style: {
              border: '1px solid white',
              margin: '0 10px',
              textAlign: 'left',
              paddingLeft: '0',
            },
          },
        ]}
        tableStyle={{ margin: '0 0 0 40px', width: 'calc(100% - 40px)' }}
      />

      {/* Ký tên */}
      <RiskHorizontalDisplay
        labels={[
          {
            image: <div style={{ display: 'none' }} />,
            style: { margin: '10px', border: '1px solid white' },
          },
          {
            value: (
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontWeight: 'bold' }}>TL. CHỦ TỊCH HĐQT</div>
                <div style={{ fontWeight: 'bold' }}>TRƯỞNG BAN TK-TH</div>
                <div style={{ margin: '60px 0 8px 0', fontSize: '14px' }}>
                  Trần Tuấn Hải
                </div>
              </div>
            ),
            style: { margin: '10px 0 10px 10px', border: '1px solid white' },
          },
        ]}
        tableStyle={{ margin: '0 0 40px 350px', width: 'calc(100% - 350px)' }}
      />
    </div>
  )
}

export default ExportPdf
